var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
var getColorSchemeByType = function (type) {
    switch (type) {
        case 'info': {
            return {
                mainBg: 'transparent',
                contour: COLORS.Control,
                guts: COLORS.Control,
            };
        }
        case 'success': {
            return {
                mainBg: COLORS.Success,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        case 'error': {
            return {
                mainBg: COLORS.Error,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        case 'white': {
            return {
                mainBg: 'transparent',
                contour: COLORS.TextWhite,
                guts: COLORS.TextWhite,
            };
        }
        case 'gray': {
            return {
                mainBg: 'transparent',
                contour: COLORS.GRAY_DARK,
                guts: COLORS.GRAY_DARK,
            };
        }
        case 'whiteInversed': {
            return {
                mainBg: COLORS.TextWhite,
                contour: COLORS.Control,
                guts: COLORS.Control,
            };
        }
        case 'blackInversed': {
            return {
                mainBg: COLORS.Control,
                contour: COLORS.TextWhite,
                guts: COLORS.TextWhite,
            };
        }
        case 'warning': {
            return {
                mainBg: COLORS.LabelsText_3,
                contour: null,
                guts: COLORS.LabelsText_3,
            };
        }
        case 'attention': {
            return {
                mainBg: 'transparent',
                contour: COLORS.LabelsText_2,
                guts: COLORS.LabelsText_2,
            };
        }
        case 'blue': {
            return {
                mainBg: COLORS.Outline_Dark,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        default: {
            return {
                mainBg: 'transparent',
                contour: null,
                guts: COLORS.Control,
            };
        }
    }
};
export var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var type = _a.type;
    var schema = getColorSchemeByType(type);
    var result = "fill: ".concat(schema.mainBg, ";");
    if (schema.contour !== '') {
        result = "".concat(result, "\n            #contour { stroke: ").concat(schema.contour, "; }");
    }
    if (schema.guts !== '') {
        result = "".concat(result, "\n            #guts { stroke: ").concat(schema.guts, "; }");
    }
    return result;
});
var templateObject_1;
